import React from "react";
import PageTransition from "../components/PageTransition";
import "../styles/Home.css";
import { motion } from "framer-motion";
import SocialIcons from "../components/SocialIcons";
import { useLanguage } from "../contexts/LanguageContext";
import { translations } from "../translations";

const Home = () => {
  const { language } = useLanguage();
  const t = translations[language].home;

  // Configuração da animação "fluida e leve"
  const springTransition = (delay) => ({
    type: "spring",
    stiffness: 100, // Suavidade da mola
    damping: 20,    // Controle da oscilação
    mass: 1,
    delay: delay
  });

  const handleScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <PageTransition>
      <div id="home" className="home-container">
        {/* Onda animada no rodapé - Dentro do container para rolar junto */}
        <div className="wave-container">
          <svg className="wave-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
            <path fill="#737373" fillOpacity="0.4" d="M0,96L48,122.7C96,149,192,203,288,234.7C384,267,480,277,576,245.3C672,213,768,139,864,133.3C960,128,1056,192,1152,213.3C1248,235,1344,213,1392,202.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>

        <main className="content">
          <div className="mobile-only">
            <SocialIcons />
          </div>

          <motion.div
            className="home-title-wrapper"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={springTransition(0.1)}
          >
            <h1 className="home-title">
              {t.greeting}{" "}
              <motion.span
                className="highlight-name"
                style={{ display: "inline-block" }}
                whileHover={{ scale: 1.05, textShadow: "0px 0px 8px rgb(255,255,255)" }}
              >
                {t.name}
              </motion.span>
            </h1>
          </motion.div>

          <motion.h2
            className="home-subtitle"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={springTransition(0.3)}
            whileHover={{ scale: 1.05, color: "#ffffff", cursor: "default" }}
          >
            {t.subtitle}
          </motion.h2>

          <motion.p
            className="home-description"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={springTransition(0.5)}
            whileHover={{ scale: 1.05, color: "#e0e0e0", cursor: "default" }}
            dangerouslySetInnerHTML={{ __html: t.description }}
          />

          <motion.div
            className="home-buttons"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={springTransition(0.7)}
          >
            <button onClick={() => handleScrollTo("projects")} className="btn-custom btn-primary">
              <span className="arrow">→</span> {t.btnProjects}
            </button>
            <button onClick={() => handleScrollTo("about")} className="btn-custom btn-secondary">
              <span className="arrow">→</span> {t.btnAbout}
            </button>
          </motion.div>
        </main>
      </div>
    </PageTransition>
  );
};

export default Home;
